export default {
  DISPLAY_LOADER: 'DISPLAY_LOADER'
}
